import { render, staticRenderFns } from "./AdminPopup.vue?vue&type=template&id=05803e02"
import script from "./AdminPopup.vue?vue&type=script&lang=js"
export * from "./AdminPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports